import React, { useMemo, useState } from "react";
import { icons } from "./BaseIcon";

const BaseIconShowPage = () => {
    const [search, setSearch] = useState("");

    const iconNames = useMemo(() => {
        return Object.keys(icons)
            .filter((name) =>
                name.toLowerCase().includes(search.toLowerCase())
            )
            .sort();
    }, [search]);

    return (
        <div style={styles.container}>
            <h2 style={styles.heading}>
                BaseIcon Gallery
            </h2>

            <div style={styles.info}>
                Showing{" "}
                <strong>{iconNames.length}</strong>
                {" "}of{" "}
                <strong>{Object.keys(icons).length}</strong>
                {" "}icons
            </div>

            {/* Search */}
            <div style={styles.searchWrapper}>
                <input
                    type="text"
                    placeholder="Search icon..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={styles.search}
                />
            </div>

            {/* Icons */}
            <div style={styles.grid}>
                {iconNames.map((name) => {
                    const IconComponent = icons[name];

                    // Safety check
                    if (!IconComponent) {
                        return null;
                    }

                    return (
                        <div
                            key={name}
                            style={styles.card}
                        >
                            <div style={styles.iconWrapper}>
                                <IconComponent
                                    size={32}
                                    width={32}
                                    height={32}
                                    color="#333"
                                />
                            </div>

                            <span style={styles.iconName}>
                                {name}
                            </span>
                        </div>
                    );
                })}
            </div>

            {iconNames.length === 0 && (
                <div style={styles.noResults}>
                    No icons found.
                </div>
            )}
        </div>
    );
};

const styles = {
    container: {
        padding: "24px",
        fontFamily: "sans-serif",
        backgroundColor: "#f7f7f7",
        minHeight: "100vh",
    },

    heading: {
        marginBottom: "8px",
        textAlign: "center",
    },

    info: {
        textAlign: "center",
        marginBottom: "20px",
        color: "#666",
        fontSize: "14px",
    },

    searchWrapper: {
        display: "flex",
        justifyContent: "center",
        marginBottom: "24px",
    },

    search: {
        width: "300px",
        maxWidth: "100%",
        padding: "10px 14px",
        border: "1px solid #ccc",
        borderRadius: "6px",
        fontSize: "14px",
        outline: "none",
    },

    grid: {
        display: "grid",
        gridTemplateColumns:
            "repeat(auto-fill, minmax(140px, 1fr))",
        gap: "16px",
    },

    card: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "110px",
        padding: "16px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        backgroundColor: "#fff",
        textAlign: "center",
    },

    iconWrapper: {
        width: "50px",
        height: "50px",
        marginBottom: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    iconName: {
        fontSize: "12px",
        color: "#333",
        wordBreak: "break-word",
    },

    noResults: {
        textAlign: "center",
        color: "#777",
        padding: "40px",
    },
};

export default BaseIconShowPage;
